import {
  isAlphabeticalOrderWord,
  maxConsecutiveAlphabetRunLength,
} from '~/boggle/lib/badges/wordAnalysis'

import type { BoggleWordLexicalTag } from './types'

export type BoggleWordMetadataLexicon = {
  isDictionaryWord: (word: string) => boolean
  lexiconVersion: string
}

export function normalizeBoggleSubmittedWord(word: string) {
  return word.trim().toLowerCase()
}

export function deriveBoggleWordLexicalTags(
  normalizedWord: string,
  lexicon: Pick<BoggleWordMetadataLexicon, 'isDictionaryWord'>,
): BoggleWordLexicalTag[] {
  const reverse = normalizedWord.split('').reverse().join('')
  const tags: BoggleWordLexicalTag[] = []

  if (normalizedWord === reverse) {
    tags.push('palindrome')
  }
  if (reverse !== normalizedWord && lexicon.isDictionaryWord(reverse)) {
    tags.push('anadrome')
  }
  if (new Set(normalizedWord).size === normalizedWord.length) {
    tags.push('isogram')
  }
  if (/(.)\1/.test(normalizedWord)) {
    tags.push('double-letter')
  }
  if (isAlphabeticalOrderWord(normalizedWord, 4, true)) {
    tags.push('alphabetical')
  }
  if (maxConsecutiveAlphabetRunLength(normalizedWord) >= 3) {
    tags.push('straight')
  }

  return tags
}
